<template>
  <div class="home">
    <div class="body">
      <div>
        <h3>
          Anda tidak memiliki akses pada halaman ini, silakan kontak Admin Anda
        </h3>
        <p>
          <a @click="$router.go(-2)" href="javascript:void(0)">Kembali ke halaman sebelumnya</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      sticky: false,
    };
  },
};
</script>

<style scoped lang="scss">
.home {
  .body {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forbidden.vue